import { render } from "./UpdateCorporatePlanCarbonTrackerComponent.vue?vue&type=template&id=6f058472"
import script from "./UpdateCorporatePlanCarbonTrackerComponent.vue?vue&type=script&lang=js"
export * from "./UpdateCorporatePlanCarbonTrackerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__